import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=ee72d6f2&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./AddPaymentMethod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports